/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { deleteDocumentFromS3 } from 'store/modules/documents_store/actions';
import { DocumentsState } from 'store/modules/documents_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import tabId from 'services/tabId';

interface DeleteDocumentModalProps {
  deleteDocumentModalOpened: boolean;
  setDeleteDocumentModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
  documentId: number;
}

const DeleteDocumentModal = (props: DeleteDocumentModalProps) => {
  const { deleteDocumentModalOpened, setDeleteDocumentModalOpened, documentId } = props;
  const dispatch = useDispatch();

  const [showError, setShowError] = useState<boolean>(false);
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [saveClicked, setSaveClicked] = useState<boolean>(false);

  const { request } = useSelector<ApplicationState, DocumentsState>(
    (state) => state.session.documents,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const SHORT_DELAY = 2000;

  useEffect(() => {
    if (!saveClicked) return;

    if (!request.delete_document.loaded) return;

    setShowSuccess(true);
    setShowError(false);
  }, [request.delete_document.loaded]);

  useEffect(() => {
    if (!saveClicked) return;

    if (!request.delete_document.error) return;

    setShowSuccess(false);
    setShowError(true);
  }, [request.delete_document.error]);

  useEffect(() => {
    if (!showSuccess) return;

    setTimeout(() => {
      setShowSuccess(false);
      setSaveClicked(false);
      setDeleteDocumentModalOpened(false);
    }, SHORT_DELAY);
  }, [showSuccess]);

  useEffect(() => {
    if (!showError) return;

    setTimeout(() => {
      setShowError(false);
    }, SHORT_DELAY);
  }, [showError]);

  return (
    <Modal show={deleteDocumentModalOpened} size="sm">
      <div className="modal-content">
        <div className="modal-header">
          <h6 className="modal-title" id="modalLabel">
            Apagar Documento
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setDeleteDocumentModalOpened(!deleteDocumentModalOpened);
            }}
          >
            <span aria-hidden="true" />
          </button>
        </div>
        <div className="modal-body">
          {showError && (
            <div className="my-2 alert alert-danger text-center">Erro ao apagar documento.</div>
          )}
          {showSuccess && (
            <div className="my-2 alert alert-success text-center p-2 d-flex align-items-center">
              Documento apagado com sucesso.
            </div>
          )}
          {true && (
            <div className="alert alert-warning" role="alert">
              Ao remover o documento a ação não poderá ser desfeita.
            </div>
          )}
          <div className="form-row">
            <button
              type="button"
              className="btn btn-md btn-block btn-danger"
              onClick={() => {
                dispatch(
                  deleteDocumentFromS3(
                    documentId,
                    profile.representant ? profile.currentCompany[tabId()] : profile.clientId,
                  ),
                );
                setSaveClicked(true);
              }}
            >
              Apagar Documento
            </button>
            <button
              type="button"
              id="close-alert"
              className="btn btn-md btn-block btn-primary"
              onClick={() => {
                setDeleteDocumentModalOpened(!deleteDocumentModalOpened);
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteDocumentModal;
